import React from 'react';
import { Link } from 'react-router-dom';
import './ISO39001.css';

const ISO39001 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">ISO 39001:2012 Road Traffic Safety Management System</h1>
            <h2 className="page-subtitle">Leave the Risks Behind: Stay Safe with ISO 39001!</h2>
            <div className="page-text-content">
              <p>
                As NQC (Nova Quality Certification Agency), we are providing safety solutions with 
                ISO 39001:2012 Road Traffic Safety Management System. This standard aims to enhance 
                safety performance and minimize risks in road traffic.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ISO 39001:2012?</h2>
            <div className="page-text-content">
              <p>
                ISO 39001:2012 is a management system standard designed to improve road traffic safety. 
                This international standard helps organizations reduce traffic accidents, enhance safety 
                performance, and demonstrate their commitment to road safety. ISO 39001:2012 promotes 
                leadership in traffic safety, reduces the number of accidents, and emphasizes corporate 
                responsibility in road traffic safety.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Key Principles of ISO 39001:2012</h2>
            <div className="principles-list">
              <div className="principle-item">
                <h3 className="principle-title">1. Commitment and Corporate Leadership</h3>
                <p className="principle-description">
                  Top management demonstrates commitment to road traffic safety and provides leadership 
                  in implementing safety measures.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">2. Employee Participation and Training</h3>
                <p className="principle-description">
                  Employees are actively involved in safety initiatives and receive regular training on 
                  road traffic safety practices.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">3. Risk Management and Control</h3>
                <p className="principle-description">
                  Organizations identify, assess, and control risks associated with road traffic 
                  operations.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">4. Emergency Preparedness and Response</h3>
                <p className="principle-description">
                  Organizations establish procedures for emergency situations and ensure effective 
                  response capabilities.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">5. Continuous Improvement</h3>
                <p className="principle-description">
                  The standard encourages organizations to continuously monitor, review, and improve 
                  their road traffic safety performance.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Advantages of ISO 39001:2012 for Businesses</h2>
            <div className="advantages-list">
              <div className="advantage-item">
                <h3 className="advantage-title">1. Reduction in Accident Numbers</h3>
                <p className="advantage-description">
                  Organizations can achieve a significant reduction in the number of accidents through 
                  ISO 39001 implementation.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">2. Legal Compliance and Risk Reduction</h3>
                <p className="advantage-description">
                  The standard ensures compliance with legal requirements and reduces legal risks.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">3. Reputation and Customer Trust</h3>
                <p className="advantage-description">
                  Safe transportation practices increase customer trust and enhance corporate reputation.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">4. Employee Satisfaction</h3>
                <p className="advantage-description">
                  A safe working environment increases employee satisfaction.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">5. Operational Efficiency</h3>
                <p className="advantage-description">
                  Effective management of risks enhances operational efficiency.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">ISO 39001 and Sustainability</h2>
            <div className="page-text-content">
              <p>
                ISO 39001:2012 provides essential guidance for organizations seeking to create 
                sustainable transportation models. Safe transportation can reduce environmental impact 
                while ensuring business continuity.
              </p>
              <p>
                Our company is here to help you discover the advantages offered by ISO 39001:2012 and 
                to guide your organization towards a safe future. Get in touch with us and enjoy the 
                leadership in safe transportation!
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO39001;

